import styled from "vue-styled-components";

export const Content = styled.div`
    position: relative;

    .modal {
        .modal-dialog {
            .modal-content {
                width: auto;
                margin: auto;
                .modal-header {
                    border: none;
                    padding-top: 0;

                    .close {
                        z-index: 1;
                        filter: brightness(0.8);
                    }
                }
                .modal-body {
                    padding: 0;
                }
            }
        }
    }

    figure {
        margin: 0;
    }
`;
